import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-what-to-do-if',
  templateUrl: './what-to-do-if.component.html',
  styleUrls: ['./what-to-do-if.component.css'],
})
export class WhatToDoIfComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
